import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, Settings } from '../config/settings';
import { combine } from '../shared/utilities/route';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MetricsService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) private readonly settings: Settings
    ) {
        this.coreApiPath = settings.coreAPIUrl;
    }

    postMetrics(eventName: string, jsonData: JSON): Observable<string> {
        const url = combine(this.coreApiPath, `metrics/event/${eventName}`);
        return this.http.post<string>(url, jsonData);
    }
}
